import React from "react";
import './AmountView.scss'

import {Grid, Header, Button, Form, Icon, Input, Message} from 'semantic-ui-react'
import InputMask from 'react-input-mask';

import {getLanguageScope, C, N, DFS, createLazyExecution} from '../../../../../helpers'

const _i18n = getLanguageScope('amounts');

class AmountView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      phone_number_check: '',
    }

    this.lazyUpdateAmounts = createLazyExecution(async function _createLazyExecution(amount) {
      const {appSetServerVal, appCall} = props;

      await appSetServerVal('original_amount', N(amount));
      await appCall('updateAmounts');
    }, 555);
  }

  async componentDidMount() {
    const {initCustomer, resetCustomer, phone_number, phone_number_valid, empty_shopping_cart} = this.props;

    if(!phone_number_valid || empty_shopping_cart){
      return await resetCustomer();
    }

    if (phone_number && phone_number_valid) {
      return await initCustomer()
    }
  }

  updateAmount(amount) {
    const {appSetVal, customer_limit_amount} = this.props;
    if (customer_limit_amount && N(amount) > customer_limit_amount) return;

    appSetVal('display_amount', N(amount));

    this.lazyUpdateAmounts(amount)
  }

  render() {
    const {
      customer_init_loading, phone_number_input_disabled, appSetVal, phone_number, show_customer_change,
      disable_confirm_button, phone_number_valid, changeNumber, initCustomer, resetCustomer, phone_number_mask,
      phoneDoubleCheck,
    } = this.props;

    const enableConfirm = phoneDoubleCheck
      ? this.state.phone_number_check && phone_number && (this.state.phone_number_check === phone_number)
      : !disable_confirm_button;
    const blurFirstInput = !!this.state.phone_number_check && !enableConfirm;
    const blurSecondInput = phoneDoubleCheck && !!phone_number && !enableConfirm;

    return (
      <div>

        <Form>
          {phoneDoubleCheck ? <Form.Field required>
            <label>{_i18n('phone_number')}</label>
            <Input loading={customer_init_loading} disabled={phone_number_input_disabled} iconPosition='left'>
              <Icon name='phone'/>
                <InputMask value={this.state.phone_number_check}
                          onChange={(e) => this.setState({phone_number_check: DFS(e.currentTarget.value)})}
                          className={[blurFirstInput ? 'blur-content' : ''].join(' ')}
                          placeholder={_i18n('phone_number')}
                          mask={phone_number_mask || "+1\ (їїї) їїї-їїїї"} formatChars={{'ї': '[0-9]'}} maskChar="_"/>
            </Input>
          </Form.Field> : null}
          <Form.Field required>
            <label>{_i18n(phoneDoubleCheck ? 'phone_number_confirm' : 'phone_number')}</label>
            <Input loading={customer_init_loading} disabled={phone_number_input_disabled} iconPosition='left'>
              <Icon name='phone'/>
              <InputMask value={phone_number}
                         onChange={(e) => changeNumber(DFS(e.currentTarget.value))}
                         className={['without-right-borders', blurSecondInput ? 'blur-content' : ''].join(' ')}
                         placeholder={_i18n('phone_number')}
                         mask={phone_number_mask || "+1\ (їїї) їїї-їїїї"} formatChars={{'ї': '[0-9]'}} maskChar="_"/>

              {show_customer_change ?
                <Button onClick={() => resetCustomer()}
                        type='submit' className='without-left-borders' color='red'
                        content={_i18n('change_customer')}/>
                :
                <Button disabled={!enableConfirm} onClick={() => initCustomer()}
                        type='submit' className='without-left-borders' color='blue' content={_i18n('confirm')}/>
              }

            </Input>
          </Form.Field>

          <Message visible={!phone_number_valid} error header={_i18n('phone_number_not_valid_header')}
                   content={_i18n('phone_number_not_valid_content')}/>
        </Form>

        {this.renderAmountsGrid()}
      </div>
    )
  }

  renderAmountInput() {
    const {hideAmountInput, denominations, display_amount, customer_limit_amount} = this.props;

    if (hideAmountInput) return null;

    const hasDenominations = denominations && denominations.length;
    let listAttr, denominationsList;

    if (hasDenominations) {
      listAttr = {list: 'denominations'};
      denominationsList =
        (<datalist id='denominations'>
          {_.map(denominations, (d, key) => <option key={key} value={d}/>)}
        </datalist>)
    }

    return (
      <Form className='mt-30 mb-30'>
        <Form.Field required>
          <Header as='label' floated='left'>
            {_i18n('enter_amount')}
          </Header>
          <Header className='amount-limit' as='label' floated='right'>
            {`(${_i18n('limit')} ${C(customer_limit_amount, '$')})`}
          </Header>
          <Input {...listAttr} icon='money' name='original_amount'
                 onChange={(e, {name, value}) => this.updateAmount(value)}
                 value={display_amount ? display_amount : ''} type='number' min={'0'} max={'9999'} iconPosition='left'
                 placeholder={_i18n('enter_amount')}/>
          {denominationsList}
        </Form.Field>
      </Form>
    )
  }


  renderAmountsGrid() {

    const {show_amount_box, display_amount, fee, requested_amount, discount_amount, customer_limit_amount} = this.props;

    if (!show_amount_box) return;

    let discountAmountView = null;
    if (discount_amount) {
      discountAmountView = (
        <Grid.Row>
          <Grid.Column>
            <Header floated='right' as={'h4'} content={`${_i18n('discount_amount')}:`}/>
          </Grid.Column>
          <Grid.Column>
            {C(discount_amount, '$')}
          </Grid.Column>
        </Grid.Row>
      )
    }

    return (
      <div>
        {this.renderAmountInput()}

        <Grid columns='two'>
          <Grid.Row>
            <Grid.Column>
              <Header floated='right' as={'h4'} content={`${_i18n('amount_paid')}:`}/>
            </Grid.Column>
            <Grid.Column>
              {C(display_amount, '$')}
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              <Header floated='right' as={'h4'} content={`${_i18n('fee')}:`}/>
            </Grid.Column>
            <Grid.Column>
              {C(fee, '$')}
            </Grid.Column>
          </Grid.Row>

          <Grid.Row>
            <Grid.Column>
              <Header floated='right' as={'h4'} content={`${_i18n('total_amount')}:`}/>
            </Grid.Column>
            <Grid.Column>
              {C(requested_amount, '$')}
            </Grid.Column>
          </Grid.Row>

          {discountAmountView}

        </Grid>
      </div>
    )
  }


}

export default AmountView


// WEBPACK FOOTER //
// ./src/components/Applications/shared/Amounts/components/AmountView.js